

const  BankDetails= ({ bankName, branchName, accountNumber, ifscCode }) => (
  <div>
    <p style={{ textAlign: 'center' }}>Bank Details</p>
    <div className="bank-details-table">
      <table style={{ width: '100%' }}>
        <thead style={{ textAlign: 'center' }}>
          <tr>
            <th style={{ border: '1px solid black', borderCollapse: 'collapse' }}>Bank Name</th>
            <th style={{ border: '1px solid black', borderCollapse: 'collapse' }}>Branch Name</th>
            <th style={{ border: '1px solid black', borderCollapse: 'collapse' }}>Account Number</th>
            <th style={{ border: '1px solid black', borderCollapse: 'collapse' }}>IFSC Code</th>
          </tr>
        </thead>
        <tbody>
          <tr style={{ textAlign: 'center' }}>
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>
              {bankName}
            </td>
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>
              {branchName}
            </td>
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>
              {accountNumber}
            </td>
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>
              {ifscCode}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
);

export default BankDetails;